import { createSpanishJourneyPlanner } from "./language-journey/spanish-planner";
import * as journeys from "./languageJourneyClient";

export * from "./language-journey/spanish-planner";
export const {
  SPANISH_JOURNEY_PLAN_VERSION,
  SPANISH_JOURNEY_LANGUAGE_CODE,
  SPANISH_JOURNEY_PROGRESS_NAMESPACE,
  SpanishJourneyGoalSchema,
  SpanishJourneyAbilitySchema,
  SpanishJourneyTeachingApproachSchema,
  SpanishJourneyStuckStrategySchema,
  SpanishJourneyCorrectionTimingSchema,
  SpanishJourneyLanguageSupportSchema,
  SpanishJourneyChallengeLevelSchema,
  SpanishJourneyTimeSchema,
  SpanishJourneyGoalProfileSchema,
  SpanishJourneyPlanItemSchema,
  SpanishJourneyPlanSchema,
  SPANISH_GOAL_LABELS,
  SPANISH_TEACHING_APPROACH_LABELS,
  SPANISH_STUCK_STRATEGY_LABELS,
  SPANISH_CORRECTION_TIMING_LABELS,
  SPANISH_LANGUAGE_SUPPORT_LABELS,
  SPANISH_CHALLENGE_LEVEL_LABELS,
  isSpanishJourneyCode,
  getSpanishJourney,
  getSpanishJourneyPlanShape,
  getSpanishJourneyAbilityForChapter,
  getSpanishJourneyStartingChapter,
  getSpanishJourneyCandidateChapters,
  buildFallbackSpanishJourneyPlan,
  normalizeGeneratedSpanishJourneyPlan,
  validateSpanishJourneyPlan,
  getSpanishJourneyPlanRecommendation,
  shouldApplySpanishJourneyRecommendation,
  getSpanishJourneyPlanCompletedCount,
  getSpanishJourneyReplacementOptions,
  replaceSpanishJourneyPlanItem,
  buildSpanishJourneyCoachingInstructions,
  extractJsonObject,
  buildSpanishJourneyPlannerPrompt,
} = createSpanishJourneyPlanner(journeys);
